export default __webpack_public_path__ + "static/media/squiggles-no-1.9c7986af.ogg";